/**
 * Ieșirea din CRM închide și sesiunea de mail (Roundcube, pluginul `crm_sso`), 22.10.2026.
 *
 * Pe un calculator comun, următorul om nu moștenește mailul celui dinainte. Se cheamă din
 * `clear()` al sesiunii, deci la orice ieșire: butonul de logout, dar și logarea expirată.
 * Roundcube stă pe altă adresă; pagina Mail o ține minte aici când îl deschide.
 */
const CHEIE = 'b4l.webmail'

export function tineMinteMailul(origine: string): void {
  try {
    localStorage.setItem(CHEIE, origine)
  } catch {
    // fără stocare: sesiunea de mail expiră singură (30 de minute)
  }
}

export function iesireDinMail(): void {
  let origine: string | null = null
  try {
    origine = localStorage.getItem(CHEIE)
    localStorage.removeItem(CHEIE)
  } catch {
    return
  }
  if (!origine) return
  void fetch(`${origine}/?_crm_iesire=1`, {
    method: 'POST',
    mode: 'no-cors',
    credentials: 'include',
    keepalive: true,
  }).catch(() => undefined)
}
